"use client";

import { CommonLogTypesSelect } from "@/entities";
import { useRouter, useSearchParams } from "next/navigation";
import { useForm, Controller } from "react-hook-form";

export function LogsFilter() {
  const searchParams = useSearchParams();
  const router = useRouter();

  const type = searchParams?.get(`type`);
  const keyword = searchParams?.get(`keyword`);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: { keyword } });

  const onSubmit = async (data: any) => {
    let url = new URL(window.location.href);
    if (type) url.searchParams.set("type", type);
    else url.searchParams.delete("type");
    if (data.keyword) url.searchParams.set("keyword", data.keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };
  const onTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let url = new URL(window.location.href);
    if (e.target.value) url.searchParams.set("type", e.target.value);
    else url.searchParams.delete("type");
    if (keyword) url.searchParams.set("keyword", keyword);
    else url.searchParams.delete("keyword");
    router.push(url.toString());
  };

  return (
    <div className="row">
      <div className="col-md-8">
        <div className="row">
          <div className="col-md-3 mb-3">
            <CommonLogTypesSelect
              defaultValue={{ key: "", value: "전체구분" }}
              onChange={onTypeChange}
              value={type ?? ""}
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="input-group mb-4">
            <Controller
              control={control}
              name="keyword"
              render={({ field: { onChange, onBlur, value } }) => (
                <input
                  type="text"
                  id="keyword"
                  className="form-control form-control-md"
                  title="검색어(메시지, 주소)를 입력해주세요."
                  placeholder="검색어(메시지, 주소) 입력"
                  value={value || ""}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              )}
            />
            <button className="btn btn-white btn-md" type="submit">
              <i className="fa fa-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
